import { useState } from 'react';
import {
    Box,
    TextField,
    Button,
    Typography,
    Paper,
    InputAdornment,
    IconButton,
} from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import Notification from '../../../../util/notifications/Notification';

// Formular zum Setzen eines neuen Passworts.
function ResetPasswordForm({ loading, message, onNotificationClose, onSubmit, onBackToLogin }) {
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(newPassword, confirmPassword);
    };

    return (
        <Paper
            elevation={3}
            sx={{
                p: { xs: 3, sm: 4 },
                width: '100%',
                maxWidth: 450,
            }}
        >
            <Box display="flex" justifyContent="center" mb={3}>
                <Box
                    sx={{
                        width: 64,
                        height: 64,
                        borderRadius: '50%',
                        bgcolor: 'primary.main',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                    }}
                >
                    <LockIcon sx={{ fontSize: 32, color: 'white' }} />
                </Box>
            </Box>

            <Typography variant="h5" align="center" gutterBottom fontWeight={700}>
                Neues Passwort setzen
            </Typography>
            <Typography variant="body2" align="center" color="text.secondary" mb={3}>
                Gib dein neues Passwort ein
            </Typography>

            {(message.status === "error" || message.status === "success") && (
                <Notification
                    type={message.type}
                    message={message.text}
                    onClose={onNotificationClose}
                />
            )}

            <Box component="form" onSubmit={handleSubmit} sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}>
                <TextField
                    label="Neues Passwort"
                    type={showPassword ? 'text' : 'password'}
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                    variant="outlined"
                    fullWidth
                    required
                    disabled={loading}
                    autoComplete="new-password"
                    InputProps={{
                        maxLength: 50,
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={() => setShowPassword(!showPassword)}
                                    edge="end"
                                >
                                    {showPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
                <TextField
                    label="Passwort bestätigen"
                    type={showConfirmPassword ? 'text' : 'password'}
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    variant="outlined"
                    fullWidth
                    required
                    disabled={loading}
                    autoComplete="new-password"
                    InputProps={{
                        maxLength: 50,
                        endAdornment: (
                            <InputAdornment position="end">
                                <IconButton
                                    onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                                    edge="end"
                                >
                                    {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                                </IconButton>
                            </InputAdornment>
                        ),
                    }}
                />
                <Button
                    type="submit"
                    variant="contained"
                    size="large"
                    fullWidth
                    disabled={loading}
                    sx={{ py: 1.5, mt: 1 }}
                >
                    {loading ? 'Wird gespeichert...' : 'Passwort ändern'}
                </Button>
                <Button
                    variant="text"
                    onClick={onBackToLogin}
                    fullWidth
                    disabled={loading}
                >
                    Zurück zum Login
                </Button>
            </Box>
        </Paper>
    );
}

export default ResetPasswordForm;
